import { render, staticRenderFns } from "./EditRequisitionItemsForm.vue?vue&type=template&id=2336ba8e&scoped=true&"
import script from "./EditRequisitionItemsForm.vue?vue&type=script&lang=ts&"
export * from "./EditRequisitionItemsForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditRequisitionItemsForm.vue?vue&type=style&index=0&id=2336ba8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336ba8e",
  null
  
)

export default component.exports